import React from "react";
import { IconName } from "../../../../../styles/icons";
import { getRTLIcon } from "../../../../../styles/language";
import { Icon } from "../../../../Icon/Icon";
import { Stack } from "../../../../Stacks/Stack/Stack";
import { ListItemColumnProps } from "../../shared/props";
import { finalColumnExtraPadding } from "../../shared/styles";

export interface FinalColumnWithIconProps extends ListItemColumnProps {
    /**
     * Child elements to add to flow.
     */
    readonly children: JSX.Element;

    /**
     * iconName to render an Icon at the far right of the column (LTR)
     */
    readonly iconName?: IconName;
}

export const FinalColumnWithIcon: React.FC<FinalColumnWithIconProps> = ({
    children,
    disabled,
    iconName
}) => (
    <Stack
        horizontal={true}
        grow={true}
        verticalAlign="center"
    >
        {children}
        {iconName && (
            <Stack padding={finalColumnExtraPadding}>
                <Icon
                    size="16px"
                    iconName={getRTLIcon(iconName!)}
                    color="neutralSecondary"
                    disabled={disabled}
                />
            </Stack>
        )}
    </Stack>
);
